import { BitcoinFaceLogoProps } from "../../store/faces";

const BitcoinFace522 = (props: BitcoinFaceLogoProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 147 147"
    width={props.width}
    height={props.height}
  >
    <g clipPath="url(#prefix__a)">
      <path fill="#FEC233" d="M150.675 0H0v150.675h150.675V0Z" />
      <path
        fill="#545290"
        d="M0 68.533 27.546 41.21v40.022M148.47 68.327 121.131 41.16v38.646"
      />
      <path fill="#545290" d="M148.41 68.314H0v78.771h148.41V68.314Z" />
      <path fill="#545290" d="M121.131 41.21H27.399v29.701h93.732V41.21Z" />
      <path fill="#DBB9BE" d="M75.088 66.78H23.773v34.435h51.315V66.781Z" />
      <path
        fill="#D7BBBD"
        d="M78.054 100.363H16.783L40.61 124.19h37.444v-23.827Z"
      />
      <path
        fill="#EFE1DA"
        d="M23.921 66.714h51.06V16.79h-1.377a22.62 22.62 0 0 0-17.897 8.788L23.921 66.714Z"
      />
      <path
        fill="#DBB9BE"
        d="M73.027 21.328h-.631v38.579h.63V21.328ZM54.818 35.902l-.521.356 14.75 21.56.52-.357-14.75-21.559Z"
      />
      <path
        fill="#FBF5DE"
        d="M64.768 34.945a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.54ZM60.229 29.272a1.135 1.135 0 1 0 0-2.27 1.135 1.135 0 0 0 0 2.27ZM62.498 38.348a1.135 1.135 0 1 0 0-2.27 1.135 1.135 0 0 0 0 2.27ZM53.421 42.887a1.135 1.135 0 1 0 0-2.27 1.135 1.135 0 0 0 0 2.27Z"
      />
      <path fill="#DBB9BE" d="M74.445 101.086h51.315V66.651H74.445v34.435Z" />
      <path
        fill="#D7BBBD"
        d="M71.479 100.266h61.271l-23.827 23.827H71.479v-23.827Z"
      />
      <path
        fill="#EFE1DA"
        d="M125.613 66.617h-51.06V16.693h1.375a22.62 22.62 0 0 1 17.898 8.788l31.787 41.136Z"
      />
      <path
        fill="#DBB9BE"
        d="M77.138 21.231h-.63V59.81h.63V21.23ZM94.716 35.803l-14.75 21.559.52.356 14.75-21.559-.52-.356Z"
      />
      <path
        fill="#FBF5DE"
        d="M84.765 34.848a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.54ZM89.304 29.175a1.135 1.135 0 1 0 0-2.27 1.135 1.135 0 0 0 0 2.27ZM87.034 38.252a1.135 1.135 0 1 0 0-2.27 1.135 1.135 0 0 0 0 2.27ZM96.112 42.79a1.135 1.135 0 1 0 0-2.27 1.135 1.135 0 0 0 0 2.27Z"
      />
      <path
        fill="#AAAECC"
        d="M29.51 78.173h-.309a15.697 15.697 0 0 1-15.695-15.698v-9.452h39.145l-23.14 25.15Z"
      />
      <path
        fill="#727FBD"
        d="M118.673 78.173h.316a15.696 15.696 0 0 0 15.688-15.698v-9.452h-32.928l16.924 25.15Z"
      />
      <path
        fill="#4D2F47"
        d="M120.96 58.74a8.004 8.004 0 0 1 5.589 13.622 8.004 8.004 0 0 1-5.589 2.381M27.223 74.743a8.003 8.003 0 0 1 0-16.003"
      />
      <path
        fill="#727FBD"
        d="M27.223 73.69a5.19 5.19 0 0 1 0-10.379M120.343 63.311a5.192 5.192 0 0 1 5.103 5.19 5.193 5.193 0 0 1-5.103 5.19"
      />
      <path
        fill="#BA3D11"
        d="M46.999 94.743a43.889 43.889 0 0 0 25.174 7.938h2.033v-7.938"
      />
      <path
        fill="#A31905"
        d="M101.58 94.702a43.9 43.9 0 0 1-25.175 7.938h-2.033v-7.938"
      />
      <path
        fill="#6C1908"
        d="m74.206 90.208-3.402-3.4-24.94 7.935h28.342v-4.535Z"
      />
      <path
        fill="#3E1B11"
        d="m74.372 90.167 3.401-3.4 24.94 7.935H74.372v-4.535Z"
      />
      <path
        stroke="#070707"
        strokeMiterlimit={10}
        strokeWidth={2.707}
        d="M117.328 67.674a18.186 18.186 0 0 1-5.414 12.95 18.184 18.184 0 0 1-13.021 5.243c-9.996-.13-17.953-8.464-17.953-18.463a5.793 5.793 0 0 0-5.794-5.793h-.272M32.42 67.674a18.194 18.194 0 0 0 18.438 18.193c9.996-.13 17.951-8.464 17.951-18.463a5.793 5.793 0 0 1 5.795-5.794h.27"
      />
      <path
        fill="#8E97C4"
        d="M32.42 67.674h36.39a18.194 18.194 0 0 1-36.39 0ZM80.77 67.507h36.389a18.195 18.195 0 0 1-36.388 0Z"
        opacity={0.57}
        style={{
          mixBlendMode: "color-dodge",
        }}
      />
      <path
        fill="#FFA520"
        d="M92.85 71.112c5.519 0 9.993-4.474 9.993-9.993s-4.475-9.993-9.993-9.993c-5.52 0-9.994 4.474-9.994 9.993 0 5.52 4.475 9.993 9.994 9.993Z"
      />
      <path
        fill="#001A1B"
        d="M92.85 67.115a5.996 5.996 0 1 0 0-11.992 5.996 5.996 0 0 0 0 11.992Z"
      />
      <path
        fill="#F7D53A"
        d="M56.873 71.112c5.519 0 9.993-4.474 9.993-9.993s-4.474-9.993-9.993-9.993c-5.52 0-9.993 4.474-9.993 9.993 0 5.52 4.474 9.993 9.993 9.993Z"
      />
      <path
        fill="#361A11"
        d="M56.873 67.115a5.996 5.996 0 1 0 0-11.992 5.996 5.996 0 0 0 0 11.992Z"
      />
      <path
        fill="#631809"
        d="m68.867 49.127 2.293 1.529a8.313 8.313 0 0 1 3.704 6.92c0 6.64-7.401 10.6-12.927 6.917L38.886 49.127"
      />
      <path
        fill="#361A11"
        d="m80.859 49.127-2.293 1.529a8.314 8.314 0 0 0-3.702 6.92c0 6.64 7.401 10.6 12.927 6.917l23.047-15.366"
      />
      <path
        stroke="#631809"
        strokeMiterlimit={10}
        strokeWidth={0.902}
        d="M42.965 61.299a14.215 14.215 0 1 0 28.431 0"
      />
      <path
        stroke="#631809"
        strokeMiterlimit={10}
        strokeWidth={0.902}
        d="M57.172 78.102A14.217 14.217 0 0 0 71.39 63.887"
      />
      <path
        fill="#361A11"
        d="M93.15 76.087a14.474 14.474 0 0 1-14.457-14.458h.484a13.974 13.974 0 0 0 27.948 0h.483a14.47 14.47 0 0 1-14.457 14.458Z"
      />
      <path
        fill="#361A11"
        d="M93.15 78.673a14.472 14.472 0 0 1-14.457-14.456h.484A13.989 13.989 0 0 0 93.151 78.19v.482Z"
      />
      <path
        fill="#F55B20"
        d="M74.264 65.64v14.983a5.683 5.683 0 0 1-5.586-6.702l1.506-8.282h4.08Z"
      />
      <path
        fill="#883A62"
        d="M74.12 65.64v14.983a5.683 5.683 0 0 0 5.587-6.702L78.2 65.64h-4.08Z"
      />
      <path
        fill="#F96020"
        d="M73.206 7.35h1.323v19.845H53.361A19.845 19.845 0 0 1 73.206 7.35Z"
      />
      <path
        fill="#D74816"
        d="M74.529 7.35h1.323a19.845 19.845 0 0 1 19.845 19.845H74.529V7.35Z"
      />
      <path fill="#FFA520" d="M92.904 25.872H57.477v2.646h35.427v-2.646Z" />
    </g>
    <defs>
      <clipPath id="prefix__a">
        <rect width={147} height={147} fill="#fff" rx={7} />
      </clipPath>
    </defs>
  </svg>
);
export default BitcoinFace522;
